import { makeAutoObservable } from "mobx";

class keyboardState {
  constructor() {
    makeAutoObservable(this);
  }

  press_key = ""; // нажатая кнопка

  setParameters = (name, value) => {
    this[name] = value;
  };
}

export default new keyboardState();
